export default __webpack_public_path__ + "static/media/transfer.8be8b93d.png";